import { Injectable } from '@angular/core';
import { BaseProvider } from '../../../../shared/providers/base-provider';
import {
  SessionTimeoutNotifier,
  SessionTimeoutHandler,
  SessionExpiryReason,
} from './session-timeout-notifier';
import { SessionTimeoutState } from './session-timeout-state';

/**
 * Provider root que gestiona el timeout de sesión.
 * Expone la misma API que el antiguo SessionTimeoutService para que AuthProvider
 * no cambie su consumo; el estado se lee vía `provider.state()` y las acciones
 * (continuar/cerrar) vía `provider.notifier`.
 */
@Injectable({ providedIn: 'root' })
export class SessionTimeoutProvider extends BaseProvider<SessionTimeoutNotifier, SessionTimeoutState> {
  constructor() {
    super(SessionTimeoutNotifier);
  }

  setOnLogoutHandler(handler: SessionTimeoutHandler | null): void {
    this.notifier.setOnLogoutHandler(handler);
  }

  setTokenExpiryMs(ms: number | null): void {
    this.notifier.setTokenExpiryMs(ms);
  }

  start(): void {
    this.notifier.start();
  }

  stop(): void {
    this.notifier.stop();
  }

  dispose(): void {
    // Limpieza RE-ARRANCABLE: como este provider es un singleton root reutilizado
    // entre sesiones, NO usamos el dispose() terminal de la base (marca _disposed
    // permanentemente). Solo detenemos timers/listeners y liberamos el handler.
    this.notifier.stop();
    this.notifier.setOnLogoutHandler(null);
  }
}

export type { SessionExpiryReason, SessionTimeoutHandler };
